/* istanbul ignore next */
const ACTIONS = {
    UPDATE_BILLING_SETUP_META: 'UPDATE_BILLING_SETUP_META',
};

/* istanbul ignore next */
const ACTION_CREATORS = {

    updateBillingSetupMeta(userMeta, vatMeta) {
        return {
            type: ACTIONS.UPDATE_BILLING_SETUP_META,
            payload: {
                userMeta,
                vatMeta
            }
        };
    },
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
